'use client';

import sidebarClasses from '@/components/Dataset/Sidebar/classes';
import { TableActionSkeleton } from '@/components/Table/Action/TableActionSkeleton';
import contentClasses from '@/components/Table/Content/classes';
import { TableHeaderActionsLoading } from '@/components/Table/Header/TableHeaderActionsLoading';
import { TableMapSkeleton } from '@/components/Table/Map/Skeleton';
import { Skeleton } from '@/components/ui/skeleton';
const TableHeaderSkeleton = () => <div className="flex gap-20 mb-10">
    <div className="flex flex-col">
      <div className="space-y-2">
        <Skeleton className="bg-secondary-readable/[0.25] h-4 w-[50px]" />
        <Skeleton className="bg-secondary-readable/[0.25] h-4 w-[25px]" />
      </div>
    </div>
    <h5>
      <div className="space-y-2">
        <Skeleton className="bg-secondary-readable/[0.25] h-4 w-[400px]" />
        <Skeleton className="bg-secondary-readable/[0.25] h-4 w-[450px]" />
      </div>
    </h5>
  </div>;
export default function DatasetLoading() {
  return <>
      <div className="flex flex-col gap-10 w-full">
        <TableHeaderSkeleton />

        <div className="relative">
          <TableHeaderActionsLoading />
        </div>

        <div className={contentClasses.wrapper}>
          <div className={contentClasses.map}>
            <TableMapSkeleton />
          </div>

          <div className={contentClasses.content}>
            <h5 className={sidebarClasses.heading}>Description</h5>
            <div className="space-y-2">
              <Skeleton className="bg-secondary-readable/[0.25] h-3 w-full" />
              <Skeleton className="bg-secondary-readable/[0.25] h-3 w-[90%]" />
              <Skeleton className="bg-secondary-readable/[0.25] h-3 w-full" />
              <Skeleton className="bg-secondary-readable/[0.25] h-3 w-[90%]" />
              <Skeleton className="bg-secondary-readable/[0.25] h-3 w-full" />
              <Skeleton className="bg-secondary-readable/[0.25] h-3 w-[90%]" />
              <Skeleton className="bg-secondary-readable/[0.25] h-3 w-full" />
              <Skeleton className="bg-secondary-readable/[0.25] h-3 w-[90%]" />
            </div>
            <div className="space-y-2">
              <Skeleton className="bg-secondary-readable/[0.25] h-3 w-full" />
              <Skeleton className="bg-secondary-readable/[0.25] h-3 w-[90%]" />
              <Skeleton className="bg-secondary-readable/[0.25] h-3 w-full" />
            </div>
          </div>
        </div>

        <TableActionSkeleton />
      </div>
    </>;
}